import { SymptomGraphsResponse, SymptomProgressResponse } from '@estercare/ester-shared'
import { appConfig } from '../../../../config'

export const getSymptomProgress = async ({
  accessToken,
}: {
  accessToken: string
}): Promise<SymptomProgressResponse> => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/symptomProgress`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  const data = await res.json()

  if (!res.ok) {
    throw new Error(data?.message || 'Failed to fetch symptom progress')
  }

  return data
}

export const getSymptomGraphs = async ({ accessToken }: { accessToken: string }): Promise<SymptomGraphsResponse> => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/symptomProgress/graphs`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  const data = await res.json()

  if (!res.ok) {
    throw new Error(data?.message || 'Failed to fetch symptom graphs')
  }

  return data
}
